import {jsonMember, jsonObject} from "typedjson";


/** Действие, навешанное на ту или иную кнопку панели инструментов. */
@jsonObject
export class DxGridToolbarAction {
  /** Тип действия выполняемого по кнопке. */
  @jsonMember({name: "type", constructor: String, emitDefaultValue: false, isRequired: false})
  private _type: string;

  /**
   * Обусловлена ли возможность выполнения действия наличием одной и только одной выбранной строки в гриде.
   */
  @jsonMember({name: "isSingleRowAction", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSingleRowAction: boolean = false;

  /**
   * Обусловлена ли возможность выполнения действия наличием нескольких выбранных строк в гриде.
   */
  @jsonMember({name: "isMultiRowAction", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isMultiRowAction: boolean = false;

  /**
   * Признак того что действие не зависит от наличия выделения.
   */
  @jsonMember({name: "isSelectionIndependent", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSelectionIndependent: boolean = false;

  // TODO: Придумать для этого флага название по-лучше! Пока у меня фонтазия иссякла :(
  /**
   * Возможность выполнения действия должна определятся при появлении выделения,
   * путем прогона критериев для каждого элемента выделения.
   */
  @jsonMember({name: "isSelectionDependent", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isSelectionDependent: boolean = false;

  /** Аргументы действия. */
  private _args: Map<string, any>;

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get isSingleRowAction(): boolean {
    return this._isSingleRowAction;
  }

  set isSingleRowAction(value: boolean) {
    this._isSingleRowAction = value;
  }

  get isMultiRowAction(): boolean {
    return this._isMultiRowAction;
  }

  set isMultiRowAction(value: boolean) {
    this._isMultiRowAction = value;
  }

  get isSelectionIndependent(): boolean {
    return this._isSelectionIndependent;
  }

  set isSelectionIndependent(value: boolean) {
    this._isSelectionIndependent = value;
  }

  get isSelectionDependent(): boolean {
    return this._isSelectionDependent;
  }

  set isSelectionDependent(value: boolean) {
    this._isSelectionDependent = value;
  }

  get args(): Map<string, any> {
    return this._args;
  }

  set args(value: Map<string, any>) {
    this._args = value;
  }

  constructor(fields?: Partial<DxGridToolbarAction>) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}
